export const Footer = () => (
  <footer className="py-12 bg-navy text-mut font-mono text-xs border-t border-line" data-testid="site-footer">
    <div className="max-w-6xl mx-auto px-6 space-y-6">
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 border-b border-line pb-6">
        <div className="font-display text-sm text-white tracking-wide">PRIVATECREDIT.COM.AU</div>
        <div className="text-[11px]">
          Enquiries forwarded to{" "}
          <a
            href="mailto:info@grow-capital.com.au"
            data-testid="footer-contact-email"
            className="text-cy font-semibold hover:underline"
          >
            info@grow-capital.com.au
          </a>
        </div>
      </div>

      <div className="text-[11px] leading-relaxed text-slate-400 font-body" data-testid="general-advice-warning">
        <strong className="text-slate-200">General Advice Warning:</strong> The information provided on this
        platform is factual and general in nature only. It does not constitute financial, investment, or legal
        advice. It has been prepared without taking into account the personal objectives, financial situation, or
        needs of any person. Wholesale investors and borrowers should obtain independent professional advice prior
        to making any financial decisions.
      </div>

      <div className="pt-4 border-t border-line flex flex-col sm:flex-row justify-between items-center text-[10px] text-slate-500 gap-2">
        <div>&copy; {new Date().getFullYear()} privatecredit.com.au. All rights reserved.</div>
        <div className="text-slate-400 italic" data-testid="sale-notice">
          Discreet notice: This category-defining digital asset is available to an aligned strategic party.
        </div>
      </div>
    </div>
  </footer>
);
